/// <reference path="../../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ContractPricingAdjustmentModalController {
        public static $inject: string[] = [
            '$mdMedia',
            '$mdDialog'
        ];

        public contract: any;
        public adjustmentType: any;

        constructor(public $mdMedia: any,
                    public $mdDialog: any) {}

        public get useFullScreen() {
            return (this.$mdMedia('xs') || this.$mdMedia('sm'));
        }

        public showModal() {
            this.$mdDialog.show({
                controller: 'AdjustmentController',
                controllerAs: 'ctrl',
                templateUrl: '/components/contract/pricing/adjustment/adjustment_modal.html',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
                fullscreen: this.useFullScreen,
                locals: {
                    contract: this.contract,
                    adjustmentType: this.adjustmentType
                }
            })
        }
    }

    getDealerwareWebComponentsModule().controller('ContractPricingAdjustmentModalController', ContractPricingAdjustmentModalController);

    export class ContractPricingAdjustmentModalDirective implements ng.IDirective {
        public restrict         : string    =   'A';
        public controller       : any       =   'ContractPricingAdjustmentModalController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            contract: '=',
            adjustmentType: '='
        };
        public transclude       : boolean   =   false;
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (scope: ng.IScope,
                                             elem: ng.IAugmentedJQuery,
                                             attrs: ng.IAttributes,
                                             ctrls: any) => {
            elem.bind('click', function() {
                ctrls.showModal();
            });
        }
    }

    getDealerwareWebComponentsModule().directive('contractPricingAdjustmentModal', () => new ContractPricingAdjustmentModalDirective());
}
